import * as R from 'ramda'
import {
  getNameDescriptionTableColumn,
  getTimeTableColumn,
} from '@/utils/common/tableColumn'
import i18n from '@/locales'
import { getDurationLabel } from '@/utils/utils'
import { isMonitorTemplateCategory } from '@Monitor/utils/monitorTemplate'
import { CATEGORY_LABEL_MAP, categories, getPoliciesValueMap } from '../config'

export default {
  created () {
    const valueMap = getPoliciesValueMap()
    this.columns = [
      getNameDescriptionTableColumn({
        onManager: this.onManager,
        edit: false,
        hideField: true,
        showDesc: false,
        slotCallback: row => {
          return (
            <side-page-trigger onTrigger={() => this.handleOpenSidepage(row)}>{ row.name }</side-page-trigger>
          )
        },
      }),
      {
        field: 'category',
        title: i18n.t('cloudenv.text_502'),
        formatter: ({ row, cellValue }) => {
          return CATEGORY_LABEL_MAP[cellValue]
        },
      },
      {
        field: 'policies',
        title: i18n.t('cloudenv.text_501'),
        width: 220,
        slots: {
          default: ({ row }) => {
            if (row.category === 'server_duration') {
              const tags = row.policies.server_duration.map(item => {
                return <a-tag class='mb-2'>{getDurationLabel(item)}</a-tag>
              })
              return [<list-body-cell-popover text={CATEGORY_LABEL_MAP[row.category] + ':' + this.$t('common_701', [row.policies.server_duration.length])} max-width="400px">
                {...tags}
              </list-body-cell-popover>]
            }
            // 监控模板只有面板配置，直接展示配置的监控指标
            if (isMonitorTemplateCategory(row.category)) {
              const panels = (row.policies && row.policies.panels) || []
              const tags = panels.map(item => <a-tag class='mb-2'>{item.label}</a-tag>)
              return [<list-body-cell-popover text={i18n.t('monitor.resource_template.panel_count') + ':' + panels.length} max-width="400px">
                <div style="display: inline-flex; flex-wrap: wrap; max-width: 40vw;">
                  {...tags}
                </div>
              </list-body-cell-popover>]
            }
            const len = Object.keys(row.policies).length
            let actionType = ''
            R.forEach((item) => {
              if (item.key === row.category) actionType = item.action
            }, categories)
            const ret = []
            R.forEachObjIndexed((value, key) => {
              ret.push(<a-tag class='mb-2'>{ valueMap[row.category][key] }{ value === true ? '' : '：' + value }</a-tag>)
            }, row.policies)
            return [<list-body-cell-popover text={i18n.t('cloudenv.text_557', [actionType, len])} max-width="400px">
              <div style="display: inline-flex; flex-wrap: wrap; max-width: 40vw;">
                {...ret}
              </div>
            </list-body-cell-popover>]
          },
        },
      },
      getTimeTableColumn(),
    ]
  },
}
